import React from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";
import Str from "shared/components/Str";
import BlankState from "shared/components/BlankState";

import "./ErrorMessage.scss";

const ErrorMessage = ({ children }) => (
	<div className="messages-error">
		<div className="messages-error-container">
			<BlankState
				title={children || _str("Oops! We couldn’t load your messages.")}
				buttons={(
					<button className="flatbutton blue-new" onClick={() => window.location.reload()}>
						<Str>Reload</Str>
					</button>
				)}
			/>
		</div>
	</div>
);

ErrorMessage.propTypes = {
	children: PropTypes.node,
};

ErrorMessage.defaultProps = {
	children: null,
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/apps/messages/components/ErrorMessage.jsx